import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { EmptyState, PageHeader } from "../components/common";
import { ApprovalCard } from "../components/panels";

const TABS = [
  { id: "mias", label: "Esperando mi aprobación" },
  { id: "solicitadas", label: "Solicitadas por mí" },
  { id: "todas", label: "Todas" },
];

export default function Aprobaciones() {
  const [params, setParams] = useSearchParams();
  const vista = params.get("vista") || "mias";
  const { user } = useAuth();
  const qc = useQueryClient();

  const { data: items, isLoading, refetch } = useQuery({
    queryKey: ["approvals", vista],
    queryFn: async () => (await api.get("/approvals", { params: { vista: vista === "todas" ? undefined : vista } })).data,
  });

  const refresh = () => { refetch(); qc.invalidateQueries({ queryKey: ["dashboard-badges"] }); };

  return (
    <div data-testid="aprobaciones-page">
      <PageHeader title="Aprobaciones" subtitle="Decisiones controladas con separación de funciones (maker-checker). Aprobar exige controles previos superados." />
      <div className="mb-4 flex flex-wrap gap-1 border-b border-slate-200" role="tablist">
        {TABS.map((t) => (
          <button key={t.id} role="tab" aria-selected={vista === t.id} onClick={() => setParams({ vista: t.id })} data-testid={`approvals-tab-${t.id}`}
            className={`-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${vista === t.id ? "border-blue-700 text-blue-800" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {isLoading ? (
        <p className="py-10 text-center text-sm text-slate-500">Cargando aprobaciones…</p>
      ) : !items?.length ? (
        <EmptyState title="Sin aprobaciones en esta vista" description="Cuando un proceso llegue a un paso de aprobación, aparecerá aquí." testid="approvals-empty" />
      ) : (
        <div className="space-y-3">
          {items.map((a) => <ApprovalCard key={a.id} appr={a} me={user} onChanged={refresh} />)}
        </div>
      )}
    </div>
  );
}
